<template>
    <LoadingPanel
        :headline="t('common.masterData.title')"
        :is-pending="isPending"
        :is-error="isError"
    >
        <div
            v-if="data"
            class="master-data"
        >
            <div class="master-data__group">
                <MasterDataItem
                    v-if="hasValue(data.riverGroupName)"
                    :label="t('generators.conditionStatus.content.masterData.labels.powerplantGroup')"
                    :value="data.riverGroupName"
                />
                <MasterDataItem
                    v-if="hasValue(data.manufacturer)"
                    :label="t('generators.conditionStatus.content.masterData.labels.manufacturer')"
                    :value="data.manufacturer"
                />
                <MasterDataItem
                    v-if="hasValue(data.powerPlantName)"
                    :label="t('generators.conditionStatus.content.masterData.labels.powerplant')"
                    :value="data.powerPlantName"
                />
                <MasterDataItem
                    v-if="hasValue(data.isoClass)"
                    :label="t('generators.conditionStatus.content.masterData.labels.isoClass')"
                    :value="data.isoClass"
                />
                <MasterDataItem
                    v-if="hasValue(data.generatorID)"
                    :label="t('generators.conditionStatus.content.masterData.labels.generatorId')"
                    :value="data.generatorID"
                />
                <MasterDataItem
                    v-if="hasValue(data.rewindingRotor)"
                    :label="t('generators.conditionStatus.content.masterData.labels.rewindingRotor')"
                    :value="data.rewindingRotor"
                />
                <MasterDataItem
                    v-if="hasValue(data.functionalLocation)"
                    :label="t('generators.conditionStatus.content.masterData.labels.technicalLocation')"
                    :value="data.functionalLocation"
                />
                <MasterDataItem
                    v-if="hasValue(data.rewindingStator)"
                    :label="t('generators.conditionStatus.content.masterData.labels.rewindingStator')"
                    :value="data.rewindingStator"
                />
                <MasterDataItem
                    v-if="hasValue(data.name)"
                    :label="t('generators.conditionStatus.content.masterData.labels.generatorName')"
                    :value="data.name"
                />
                <MasterDataItem
                    v-if="hasValue(data.newSheetMetal)"
                    :label="t('generators.conditionStatus.content.masterData.labels.newSheetMetal')"
                    :value="data.newSheetMetal"
                />
                <MasterDataItem
                    :label="t('generators.conditionStatus.content.masterData.labels.constructionYear')"
                    :value="data.yearOfConstruction || 'N/A'"
                />
                <MasterDataItem
                    v-if="hasValue(data.nominalPower)"
                    :label="t('generators.conditionStatus.content.masterData.labels.nominalPower')"
                    :value="data.nominalPower"
                />
                <MasterDataItem
                    v-if="hasValue(data.windingType)"
                    :label="t('generators.conditionStatus.content.masterData.labels.windingType')"
                    :value="data.windingType"
                />
                <MasterDataItem
                    v-if="hasValue(data.nominalVoltage)"
                    :label="t('generators.conditionStatus.content.masterData.labels.nominalVoltage')"
                    :value="data.nominalVoltage"
                />
                <MasterDataItem
                    v-if="hasValue(data.turbinePower)"
                    :label="t('generators.conditionStatus.content.masterData.labels.turbinePower')"
                    :value="data.turbinePower"
                />
                <MasterDataItem
                    v-if="hasValue(data.nominalCurrent) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.nominalCurrent')"
                    :value="data.nominalCurrent"
                />
                <MasterDataItem
                    v-if="hasValue(data.frequency) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.frequency')"
                    :value="data.frequency"
                />
                <MasterDataItem
                    v-if="hasValue(data.maximumSpeed) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.maximumSpeed')"
                    :value="data.maximumSpeed"
                />
                <MasterDataItem
                    v-if="hasValue(data.efficiency) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.efficiency')"
                    :value="data.efficiency"
                />
                <MasterDataItem
                    v-if="hasValue(data.nominalSpeed) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.nominalSpeed')"
                    :value="data.nominalSpeed"
                />
                <MasterDataItem
                    v-if="hasValue(data.nominalCosPhi) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.nominalCosPhi')"
                    :value="data.nominalCosPhi"
                />
                <MasterDataItem
                    v-if="hasValue(data.excitation) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.technicalPlaceExcitation')"
                    :value="data.excitation"
                />
                <MasterDataItem
                    v-if="hasValue(data.isolationSystem) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.isolationSystem')"
                    :value="data.isolationSystem"
                />
                <MasterDataItem
                    v-if="hasValue(data.excitationType) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.excitationType')"
                    :value="data.excitationType"
                />
                <MasterDataItem
                    v-if="hasValue(data.coolingMedium) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.coolingMedium')"
                    :value="data.coolingMedium"
                />
                <MasterDataItem
                    v-if="hasValue(data.excitationCurrent) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.excitationCurrent')"
                    :value="data.excitationCurrent"
                />
                <MasterDataItem
                    v-if="hasValue(data.coolingType) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.coolingType')"
                    :value="data.coolingType"
                />
                <MasterDataItem
                    v-if="hasValue(data.excitationVoltage) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.excitationVoltage')"
                    :value="data.excitationVoltage"
                />
                <MasterDataItem
                    v-if="hasValue(data.manufacturerNumber) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.manufacturersNumber')"
                    :value="data.manufacturerNumber"
                />
                <MasterDataItem
                    v-if="hasValue(data.yearOfConstructionExcitation) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.yearOfConstructionExcitation')"
                    :value="data.yearOfConstructionExcitation"
                />
                <MasterDataItem
                    v-if="hasValue(data.typeDesigantionManufacturer) && showMore"
                    :label="t('generators.conditionStatus.content.masterData.labels.typeDesignationManufacturer')"
                    :value="data.typeDesigantionManufacturer"
                />
            </div>

            <pbl-button
                v-if="data.typenschildAnalysis && !isExportLayout"
                variant="primary"
                type="button"
                compact
                class="master-data__button"
                @click="onViewImagesClick(data.typenschildAnalysis, MeasurementType.Typenschild)"
            >
                {{ t('generators.conditionStatus.content.masterData.labels.typenschild') }}
            </pbl-button>
        </div>
        
        <template v-if="!isExportLayout" #context>
            <pbl-button
                variant="primary"
                type="button"
                compact
                @click="onToggleShowMore"
            >
                {{ showMore ? t('common.showLess') : t('common.showMore') }}
            </pbl-button>
        </template>
    </LoadingPanel>
</template>

<script setup lang="ts">
import LoadingPanel from '@/components/panel/LoadingPanel.vue'
import { useI18n } from 'vue-i18n'
import MasterDataItem from '@/components/master-data/MasterDataItem.vue'
import { ref, toRefs } from 'vue'
import { useGeneratorDetailsQuery } from '@/api/queries/generators/useGeneratorDetailsQuery'
import { hasValue } from '@/utils/master-data-utils'
import { useGeneratorsReportDetailsExportStateStore } from '@/store/reports/export/generators/exportReportStateStore'
import { useGeneratorsExportStateStore } from '@/store/generators/exportStateStore'
import { useRouter } from 'vue-router'
import { ReportType } from '@/configuration/report/report-types'
import { MeasurementType } from '@/configuration/measurements/measurement-types'

const props = defineProps<{
    generatorId: string
    showMoreDefault?: boolean
    isExportLayout?: boolean
}>()

const { generatorId, showMoreDefault } = toRefs(props)

const { t } = useI18n()
const router = useRouter()

const generatorsReportDetailsExportStateStore = useGeneratorsReportDetailsExportStateStore()
const generatorsExportStateStore = useGeneratorsExportStateStore()

const showMore = ref(showMoreDefault.value ?? false)
const { data, isPending, isError } = useGeneratorDetailsQuery(generatorId.value)

const onToggleShowMore = () => {
    showMore.value = !showMore.value

    generatorsReportDetailsExportStateStore.reportDetailsExportParameters.masterDataShowMore = showMore.value ? 'true' : undefined
    generatorsExportStateStore.conditionStatusExportParameters.masterDataShowMore = showMore.value ? 'true' : undefined
}

const onViewImagesClick = (reportNumber: string, analysisType?: number) => {
    const componentSid = generatorId.value
    if (!componentSid) {
        return
    }

    router.push({
        name: 'Reports_Images_View',
        params: {
            componentSid,
            reportNumber: reportNumber,
            reportType: ReportType.GeneratorStatusReport,
        },
        query: {
            focused: analysisType ?? undefined,
        },
    })
}
</script>

<style scoped lang="scss">
.master-data {
    display: flex;
    flex-direction: column;
    row-gap: $spacing-m;

    &__group {
        display: grid;
        grid-template-columns: repeat(4, 1fr);

        row-gap: $spacing-2xs;
        column-gap: $spacing-xs;

        :global(.master-data-item:nth-child(4n+2)) {
            margin-right: $spacing-m;
        }
    }

    &__button {
        width: fit-content;
    }
}
</style>
